<div>

    <google-chart #chart *ngFor="let item of chartgoogle"
   [title]="item.title"
   [type]="item.type"
   [data]="item.data"
   [columns]="item.columnNames"
   [options]="options"
   [width]="width"
   [height]="height">
</google-chart>

</div>